<script setup lang="ts">
import { FormInputText } from "../types";
import { createFormStore } from "../form.store";
import { eventBus } from "../event_bus";

/////////////////////////////////////////////////////////////
//////////////////////// PROPS //////////////////////////////
/////////////////////////////////////////////////////////////
const props = defineProps<{
  config: FormInputText;
  modelValue: string | number;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string | number): void;
}>();
/////////////////////////////////////////////////////////////
////////////////////// VARIABLES /////////////////////////////
/////////////////////////////////////////////////////////////
const subscriptionIds = ref<string[]>([]);

/////////////////////////////////////////////////////////////
////////////////////// COMPUTED /////////////////////////////
/////////////////////////////////////////////////////////////
const value = computed({
  get: () => props.modelValue,
  set: (value: string | number) => {
    emit("update:modelValue", value);
    eventBus.emit(`form.update.${props.config.name}`);
  },
});

/////////////////////////////////////////////////////////////
////////////////////// METHODS //////////////////////////////
/////////////////////////////////////////////////////////////
function load(): void {
  // Check if we have a computed value
  if (props.config.computed) {
    const formStore = createFormStore();
    value.value = props.config.computed(formStore.formValues);
  }

  // Check if we have a subscription
  if (props.config.refreshOn) {
    props.config.refreshOn.forEach((event) => {
      const subscriptionId = eventBus.subscribe(event, load);
      subscriptionIds.value.push(subscriptionId);
    });
  }
}

function format() {
  value.value = props.config.formatter ? props.config.formatter(value.value) : value.value;
}

/////////////////////////////////////////////////////////////
////////////////////// HOOKS ////////////////////////////////
/////////////////////////////////////////////////////////////

onMounted(() => {
  load();
});

onBeforeUnmount(() => {
  subscriptionIds.value.forEach((id) => eventBus.unsubscribe(id));
});
</script>

<template>
  <AppTextField
    v-model="value"
    v-bind="{ ...config, size: undefined }"
    :disabled="disabled || config.disabled"
    :label="config.label ? $t(config.label) : undefined"
    @blur="format"
  />
</template>
